<template >
<div>

<button v-if="items.length > 0" @click="showPayments()" type="button" class="btn btn-link mb-1"><strong>{{ btn_text }}</strong></button>

<div v-if="payments.length > 0">
    
 <div v-for="item in payments" v-bind:key="item.rowId" class="form-group">
    
    <div   class="input-group">
        <div class="input-group-prepend">
          
          <div :style="{backgroundColor : item.bg_color ? item.bg_color : '#fffacd', color:'black',width:'150px'}" class="input-group-text"><strong>{{item.payment}}</strong>  </div>
            <span class="input-group-text"> €</span>
          </div>
          <input :disabled="disabled"  @input="setTotal()" ref="inputOtherPayment" type="number" step="0.01"  :style="{fontSize: '20px'}" class="form-control" id="'inputOtherPayment' + `${index}`" :placeholder="item.payment" v-model="item.total">
    </div>  
  </div>
</div>
</div>    
    </template>
    <script>
    import api                      from '@/api'
    import { mapGetters }             from 'vuex';
          
    export default {
     
      props : ['disabled'], 
      
     data () {
        return {
        
        items     : [],        
        payments  : [],
        btn_text  : 'ALTRI PAGAMENTI'  

        
        }
      },

      computed: {
        ...mapGetters(['company','storeId']) 
      },

    mounted()
    {
         this.getData('hide')  
         //this.total = this.total.toFixed(2)
    },  
    created()
    {
      
      
      
      
    },
    methods : {
    
    showPayments()
    {
      //this.showPayments=!this.showPayments 
      if(this.payments.length > 0)
      {
        this.payments = []
        this.$emit('update',[])
        this.btn_text = 'ALTRI PAGAMENTI'
      }
      else
      {
        this.btn_text = 'ANNULLA ALTRI PAGAMENTI'
        this.getData('show')  
      }
      
    },  
    setTotal()
    {
      console.log('Total')
      this.$emit('update',this.payments)
        
    },
    async getData(type) 
    {
      this.payments = []      
      
      const sp    = {'sp'        : 'spCompanyOtherPayment'} 
      const data  = {'companyId' : this.company.Id}
      const json  = Object.assign(data, sp)
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
           
            if(res.data.recordsets[0].length > 0 )
            {
              console.log(res.data.recordsets[0])
              this.items = res.data.recordsets[0]
              this.payments = []
              if(type == 'show')
              {
                this.payments = res.data.recordsets[0]
              
                this.payments.forEach(item => {
                item.total = 0
                //const total = item.total.toFixed(2)
                //item.total = total
              });  
              }
              
              this.$emit('update',this.payments)
                            
            }

            
                 
          }
          else if(res.status==500)
          {
            console.log(res)        
          
          } 
          else
          {
            
          
          } 
      }).catch(err => 
      {

        
        console.log(err.message)    
        /*
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1
        */

      }).finally(() => {
        
      });
    },



    
    
}
}
    </script>
    <style scoped>
    input{
        font-size: 24px;
    }
    .btn-link1 {
      color : green
    }
    </style>
    